/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-indent */
import React from 'react';
import PropTypes from 'prop-types';
import FieldValue from './FieldValue';
import { FilteredList } from '../index';
import './FilteredListField.scss';

export default function FilteredListField({
  style, label, children, value: selected, onChange: onFieldChange, options, serialize, error
}) {
  return (
    <FieldValue
      style={style}
      className="form-filtered-list-field"
      label={label}
      error={error}
    >
      <FilteredList list={options}>
        {(list, value, onChange) => {
          return (
            <div className="filtered-list">
              <input
                type="text"
                value={value}
                onChange={(e) => {
                  onChange(e.target.value);
                }}
              />
              <div className="list">
                {list.map((element) => {
                  const serialized = serialize(element);
                  const isSelected = selected.includes(serialized);
                  return (
                    <div
                      key={serialized}
                      onClick={() => {
                        if (isSelected) {
                          selected.splice(selected.indexOf(serialized), 1);
                        } else {
                          selected.push(serialized);
                        }
                        onFieldChange({
                          target: {
                            value: selected,
                          },
                        });
                      }}
                      className={isSelected ? 'selected' : ''}
                    >
                      {isSelected ? (
                        <i className="material-icons">check_box</i>
                      ) : (
                        <i className="material-icons">check_box_outline_blank</i>
                      )}
                      {children(element)}
                    </div>);
                })}
              </div>
            </div>
          );
        }}
      </FilteredList>
    </FieldValue>
  );
}

FilteredListField.propTypes = {
  style: PropTypes.shape(),
  options: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  label: PropTypes.string,
  value: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.shape(),
    PropTypes.string,
  ])),
  onChange: PropTypes.func.isRequired,
  children: PropTypes.func.isRequired,
  serialize: PropTypes.func,
  error: PropTypes.node,
};

FilteredListField.defaultProps = {
  style: {},
  label: '',
  value: [],
  error: null,
  serialize: (element) => {
    return element.id;
  },
};
